import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp} from "../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../date-time/iso-and-unix";
import type { EntityState } from "../entity-status";
import type { MetaContent } from "../meta-content/meta-content";
import type { ProviderId } from "../providers/provider-id";
import type { PrinterId} from "./printer-id";
import { printerIdFactory } from "./printer-id";
import type { PrinterJobType } from "./printer-job";

type PrinterType = "STAR";

type Printer = {
    readonly _id: PrinterId;
    readonly _type: "PRINTER";

    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _status: EntityState;
    readonly meta: MetaContent;
    readonly providerId: ProviderId;
    readonly active: boolean;
    readonly printerType: PrinterType;

    readonly options: {
        supportedTypes: PrinterJobType[];
    };
};

const createPrinter = (
    params: Except<Printer, "_id" | "_type" | "_status" | "_createdAt">,
): Printer => {
    return {
        ...params,
        _id: printerIdFactory(),
        _type: "PRINTER",
        _status: "ACTIVE",
        _createdAt: nowIsoAndUnix(),
    };
};

export { createPrinter };
export type { Printer };
